
export const ValidateTankAdminFuncInput = (tank, _createErrorMessage) => {
  if (!tank) {
    _createErrorMessage("54");
    return false;
  }

  return true;
};
